import { jsx } from "react/jsx-runtime";
import "react";
import { StreamingStatusContext } from "./StreamingStatusContext.js";
const StreamingStatusProvider = ({ children, value })=>/*#__PURE__*/ jsx(StreamingStatusContext.Provider, {
        value: value,
        children: children
    });
export { StreamingStatusProvider };
